import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { slideDownUp } from 'src/app/shared/animations';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ISidebarMenuItem, UserRole } from './sidebar-menu.interface';
import { getSidebarConfig } from './sidebar-menu.config';

@Component({
    selector: 'lc-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule, IconModule],
    animations: [slideDownUp],
})
export class SidebarMenuComponent {
    private readonly authService = inject(AuthService);

    /**
     * Estado dos accordions ativos
     */
    readonly activeDropdown = signal<string[]>([]);

    /**
     * Configuração do menu baseada no usuário atual
     */
    readonly menuConfig = computed(() => {
        const user = this.authService.user();
        const role = (user?.role as UserRole) || 'OTHERS';
        return getSidebarConfig(role);
    });

    /**
     * Seções visíveis do menu
     */
    readonly visibleSections = computed(() => {
        return this.menuConfig().sections.filter(section => section.isVisible !== false);
    });

    /**
     * Alterna estado do accordion
     */
    toggleAccordion(sectionId: string): void {
        const current = this.activeDropdown();
        if (current.includes(sectionId)) {
            this.activeDropdown.set(current.filter(id => id !== sectionId));
        } else {
            this.activeDropdown.set([...current, sectionId]);
        }
    }

    /**
     * Verifica se accordion está ativo
     */
    isAccordionActive(sectionId: string): boolean {
        return this.activeDropdown().includes(sectionId);
    }

    /**
     * Verifica se item tem filhos
     */
    hasChildren(item: ISidebarMenuItem): boolean {
        return !!(item.children && item.children.length > 0);
    }

    /**
     * Retorna itens visíveis de um menu
     */
    getVisibleItems(items: ISidebarMenuItem[]): ISidebarMenuItem[] {
        return items.filter(item => item.isVisible !== false);
    }
}
